import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useDarkModeStore = defineStore("darkMode", () => {
  // State
  const isDarkMode = ref(false);

  // Getters
  const darkModeEnabled = computed(() => isDarkMode.value);

  // Actions
  function initDarkMode() {
    // On page load or when changing themes, best to add inline in `head` to avoid FOUC
    const prefersDark =
      typeof window !== "undefined" &&
      Boolean(window.matchMedia?.("(prefers-color-scheme: dark)")?.matches);

    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) && prefersDark)
    ) {
      isDarkMode.value = true;
      document.documentElement.classList.add("dark");
    } else {
      isDarkMode.value = false;
      document.documentElement.classList.remove("dark");
    }
  }

  function setDarkMode() {
    localStorage.theme = "dark";
    initDarkMode();
  }

  function setLightMode() {
    localStorage.theme = "light";
    initDarkMode();
  }

  function setAutoMode() {
    localStorage.removeItem("theme");
    initDarkMode();
  }

  function $reset() {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("theme");
    }
    isDarkMode.value = false;
    if (typeof document !== "undefined") {
      document.documentElement.classList.remove("dark");
    }
  }

  return {
    isDarkMode,
    darkModeEnabled,
    initDarkMode,
    setDarkMode,
    setLightMode,
    setAutoMode,
    $reset,
    reset: $reset,
  };
});
